import { render } from "./SignageLists.vue?vue&type=template&id=dc0281e8&scoped=true&ts=true"
import script from "./SignageLists.vue?vue&type=script&lang=ts"
export * from "./SignageLists.vue?vue&type=script&lang=ts"

import "./SignageLists.vue?vue&type=style&index=0&id=dc0281e8&lang=css"
import "./SignageLists.vue?vue&type=style&index=1&id=dc0281e8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc0281e8"]])

export default __exports__